import React from "react";
import { ArrowRight, Utensils, Wine, Coffee, ShoppingBag } from "lucide-react";
import { Card } from "@/components/ui/card";

const gloriaFoodButtonsHero = (
  <div className="mt-6 flex flex-wrap gap-3" data-testid="hero-gloriafood-buttons">
    <span
      className="glf-button inline-flex items-center justify-center rounded-full bg-[#7ED956] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#6ac445]"
      data-glf-cuid="9355d15b-6f1a-4b1c-ad74-8f75ce295108"
      data-glf-ruid="111089d3-19e8-419f-bf42-1843cf64f484"
      data-testid="hero-bestel-button"
    >
      Bekijk het Menu &amp; Bestel
      <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
    </span>
    <span
      className="glf-button reservation inline-flex items-center justify-center rounded-full border border-[#7ED956] bg-white/90 px-5 py-2.5 text-sm font-semibold text-[#3E2723] hover:bg-[#f0ebdd]"
      data-glf-cuid="9355d15b-6f1a-4b1c-ad74-8f75ce295108"
      data-glf-ruid="111089d3-19e8-419f-bf42-1843cf64f484"
      data-glf-reservation="true"
      data-testid="hero-reserveer-button"
    >
      Tafelreservatie
    </span>
    <script src="https://www.fbgcdn.com/embedder/js/ewm2.js" defer async></script>
  </div>
);

const highlights = [
  {
    icon: Utensils,
    title: "Authentieke Cubaanse keuken",
    description:
      "Recepten recht uit Cuba, bereid door Ada en haar mama Maya met familiepassie.",
    testId: "highlight-authentieke-keuken",
  },
  {
    icon: Wine,
    title: "Cocktails & Cubaanse rum",
    description: "Mojito, Cuba Libre en meer – altijd vers geschud en vol smaak.",
    testId: "highlight-cocktails",
  },
  {
    icon: Coffee,
    title: "Verse sappen & Cubaanse koffie",
    description: "Tropical smoothies, huisgemaakte limonade en sterk geurige koffie.",
    testId: "highlight-koffie-sappen",
  },
  {
    icon: ShoppingBag,
    title: "Afhaal & reservatie",
    description: "Bestel eenvoudig online of reserveer je tafel in een paar klikken.",
    testId: "highlight-afhaal-reservatie",
  },
];

const Home = () => {
  return (
    <main
      className="min-h-screen bg-[#F5F1E8] text-[#3E2723]"
      data-testid="home-page"
    >
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-[url('https://images.pexels.com/photos/4457153/pexels-photo-4457153.jpeg')] bg-cover bg-center"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/40 to-black/55" aria-hidden="true" />
        <div className="relative mx-auto flex max-w-6xl flex-col px-4 pb-20 pt-28 md:px-6 md:pb-28 md:pt-36">
          <div className="max-w-xl">
            <p className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-xs font-medium uppercase tracking-[0.18em] text-[#F5F1E8] backdrop-blur-sm">
              Aroma Cubana · Sint-Niklaas
            </p>
            <h1 className="mt-5 font-['Fraunces',_serif] text-4xl leading-tight text-[#F5F1E8] md:text-6xl">
              Authentieke Cubaanse smaken in Sint-Niklaas
            </h1>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-[#F5F1E8]/90 md:text-base">
              Huisgemaakte Cubaanse gerechten, cocktails en sfeer — recht uit Cuba, met liefde geserveerd in het hart van het Waasland.
            </p>
            {gloriaFoodButtonsHero}
          </div>
        </div>
      </section>

      <section
        className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-18"
        data-testid="highlights-section"
      >
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-['Fraunces',_serif] text-2xl text-[#3E2723] md:text-3xl">
              Warm Cubaans eetcafé met een Belgisch hart
            </h2>
            <p className="mt-3 max-w-xl text-sm md:text-base text-[#3E2723]/80">
              Van geurige stoofpotjes en krokante tostones tot verfrissende limonade en Cubaanse koffie – bij Aroma Cubana proef je de smaken van Cuba, gewoon in Sint-Niklaas.
            </p>
          </div>
        </div>
        <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {highlights.map((item) => (
            <Card
              key={item.title}
              className="group flex flex-col gap-3 rounded-2xl border border-[#3E2723]/10 bg-white/60 p-5 shadow-sm backdrop-blur-sm hover:border-[#7ED956]"
              data-testid={item.testId}
            >
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#7ED956]/10 text-[#7ED956]">
                <item.icon className="h-5 w-5" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-sm font-semibold tracking-tight text-[#3E2723] md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-[#3E2723]/80 md:text-sm">
                  {item.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;
